<template>
  <div class="home">
    <div class="home-bg-box" :style="{'background-image': 'url(' + (coverImgUrl) + ')'}"></div>
    <div class="home-bg-box-color box-background"></div>
    <section class="page-content">
      <div class="background-color bgc-active"></div>
      <!-- 页面头部 -->
      <div class="home-header-bgc"></div>
      <header class="home-header">
        <!-- 头部logo -->
        <div class="header-logo">
          <img src="../assets/images/logo2.png" class="logo-pic"/>
          <span class="logo-title">{{ $t('loginPage.tysfglpt') }}</span>
        </div>
        <!-- 头部右侧功能区域 -->
        <div class="home-actions">
          <!-- <p class="skill-group-name" @click="doJumpSkillGroup">颐海工作组架构</p> -->
          <img src="../assets/images/unified-avator.png" class="avator"/>
          <Dropdown style="align-self: center;" @on-click="changeDropDown">
            <a href="javascript:void(0)">
                {{userInfo.name}}
                <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
                <DropdownItem name="changePassword">{{ $t('loginPage.xgmm') }}</DropdownItem>
                <DropdownItem name="BackgroundPic">{{ $t('ghbj') }}</DropdownItem>
                <DropdownItem name="defaultPic">{{ $t('hymr') }}</DropdownItem>
            </DropdownMenu>
        </Dropdown>
        <Dropdown transfer trigger="hover" style="margin:9px 0 0 0px;">
          <svg class="icon home-icon table-span" aria-hidden="true" style="font-size:18px">
            <use xlink:href="#icon-pifu"></use>
          </svg>
          <DropdownMenu slot="list">
            <div class="change-skin-box scrollbar">
              <span class="skin" :style="{ 'background': item.skinColor }" @click="onChangeSkin(item.skinColor)" v-for="item in skinList" :key="item.id"></span>
            </div>
          </DropdownMenu>
        </Dropdown>
        <svg class="icon home-icon table-span" aria-hidden="true" @click="doExit" style="font-size:18px">
          <use xlink:href="#icon-tuichu"></use>
        </svg>
        <!-- <common-icon type="_signout" :size="18" class="home-icon table-span" @click.native="doExit"></common-icon> -->
        </div>
      </header>
      <!-- 页面主体 -->
      <article class="home-container">
        <Carousel v-model="carouselPageNo" dots="outside">
          <CarouselItem v-for="(arr, index) in systemList" :key="index">
            <div class="page-middle">
              <ul class="middle-items" v-if="systemList.length <= 6">
                <template v-for="(item, itemIndex) in arr">
                  <li class="middle-up-item table-span" :key="item.appId" @click="doJumpSystem(item.appSign)">
                    <!-- <a v-if="item.appName" :href="`${baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${token}`" :target="item.appSign"> -->
                      <div class="item-content" v-if="item.appName">
                        <p class="title">{{item.appName}}</p>
                        <Icon type="ios-arrow-forward" size="25" class='title-arrow-right'/>
                        <p class="desc">{{item.remark}}</p>
                        <span class="number">{{itemIndex + 1 &lt; 10 ? `0${itemIndex + 1}` : itemIndex + 1}}</span>
                      </div>
                    <!-- </a> -->
                    <div class="item-content" v-else>
                      <p class="title"></p>
                      <p class="desc"></p>
                      <span class="number">{{itemIndex + 1 &lt; 10 ? `0${itemIndex + 1}` : itemIndex + 1}}</span>
                    </div>
                  </li>
                </template>
              </ul>
              <ul class="middle-items" v-else>
                <li class="middle-up-item table-span" v-for="(item, index) in systemList.slice(0, 5)" :key="index" @click="doJumpSystem(item.appSign)">
                  <!-- <a :href="`${baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${token}`" :target="item.appSign"> -->
                    <div class="item-content">
                      <p class="title">{{item.appName}}</p>
                      <Icon type="ios-arrow-forward" size="25" class='title-arrow-right'/>
                      <p class="desc">{{item.remark}}</p>
                      <span class="number">{{itemIndex + 1 &lt; 10 ? `0${itemIndex + 1}` : itemIndex + 1}}</span>
                    </div>
                  <!-- </a> -->
                </li>
                <li class="middle-up-item table-span middle-up-item-more" @click="doOpenshowMore">
                  <div class="item-content">
                    <p class="more">{{ $t('ckgd') }}<Icon type="ios-arrow-forward" size="35"/></p>
                  </div>
                </li>
              </ul>
            </div>
          </CarouselItem>
        </Carousel>
      </article>
      <!-- 页面底部 -->
      <footer class="home-footer">
        <div class="footer-title">
          <!-- <div class="footer-icon" v-show="showLinks">
            <common-icon type="_ico_open" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
            <common-icon type="_ico_open" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
            <common-icon type="_ico_open" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
          </div>
          <div class="footer-icon" v-show="!showLinks">
            <common-icon type="_arrow-up" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
            <common-icon type="_arrow-up" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
            <common-icon type="_arrow-up" :size="14" class="table-span" @click.native="showLinks = !showLinks"></common-icon>
          </div> -->
          <span class="table-span" @click="doJumpExternalLinks">{{ $t('loginPage.wbll') }}</span>
        </div>
        <!-- <div class="footer-content-bgc" v-show="showLinks"></div>
        <div class="footer-content" v-show="showLinks">
          <common-icon type="_zuojiantou" :size="22" class="footer-content-icon table-span" @click.native="doGetPreviousPage"></common-icon>
          <ul>
            <li class="footer-content-item table-span" v-for="(item, index) in externalLinksList" :key="index">
              <span @click="doClickLocation(item.linkAddr, item.id)">
                <img :src="item.image" alt="">
              </span>
            </li>
          </ul>
          <common-icon type="_arrow-right" :size="22" class="footer-content-icon table-span" @click.native="doGetNextPage"></common-icon>
        </div> -->
      </footer>
    </section>
    <!-- 查看更多弹窗 -->
    <div class="showMoreModal" v-show="showMoreflag">
      <div class="showMore-content">
        <div class="showMore-header">
          <span>{{ $t('thtymhqxqbxt') }}</span>
          <Icon type="md-close" :size="23" class="showMore-Close table-span" @click="doCloseShowMoreModal"/>
        </div>
        <div class="showMore-container">
          <ul>
            <li class="table-span" v-for="(item, index) in systemList" :key="index">
              <a :href="`${baseUrl}/sso/redirect/autoLogin?appSign=${item.appSign}&authorization=${token}`" :target="`sso${item.appSign}`">
                <div>{{item.appName}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 自定义底图弹窗 -->
    <Modal
      :closable="false"
      :transfer="false"
      :mask-closable="false"
      :width="720"
      :styles="{top: '240px'}"
      class-name="upload-modal"
      v-model="changeBackgroundPicModal">
      <p slot="header">
        <span style="float: left;">自定义底图</span>
        <Icon type="md-close" :size="20" class="table-span" style="float: right;" @click="changeBgPicCancel"/>
      </p>
      <Row class-name="upload-container">
        <Col span="3">
          <span class="upload-title">选择图片</span>
        </Col>
        <Col span="11" style="margin-left: -15px;">
          <Upload
            ref="upload"
            accept='.png,.jpg'
            :format="['png','jpg']"
            :headers="uploadToken"
            :max-size="4096"
            :show-upload-list="true"
            :action="`${baseUrl}/sso/imageFile/uploadImage`"
            :on-success="doUploadSuccess"
            :on-error="doUploadError"
            :on-exceeded-size="handleExceededSize"
            :on-format-error="handleFormatError"
            >
            <Input readonly type="text" v-model="uploadName"></Input>
            <common-icon type="_ic_attachfile" :size="20" class="table-span upload-input-icon"></common-icon>
          </Upload>
          <span style="color: #999999;">图片格式png、jpg格式</span>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="primary" @click="changeBgPicConfirm">确定</Button>
        <Button @click="changeBgPicCancel">取消</Button>
      </div>
    </Modal>
    <!-- 修改密码弹窗 -->
    <Modal
      :closable="false"
      :transfer="false"
      :mask-closable="false"
      :width="720"
      :styles="{top: '240px'}"
      v-model="changePasswordModal">
      <p slot="header">
        <span style="float: left;">修改密码</span>
        <Icon type="md-close" :size="20" class="table-span" style="float: right;" @click="changePswCancel"/>
      </p>
      <Row>
        <Col span="24" style="margin-bottom: 25px;">
          <span style="font-weight: bold; margin-right: 10px;">账户名</span><span>{{userInfo.userName}}</span>
        </Col>
      </Row>
      <Form ref="changeFormValidate" :model="changeFormValidate" :rules="changeRuleValidate" :label-width="80">
        <Row>
          <Col span="14">
            <FormItem label="原密码" prop="originPassword">
              <Input v-model="changeFormValidate.originPassword" type="password" password></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="14">
            <FormItem label="新密码" prop="newPassword">
              <Input v-model="changeFormValidate.newPassword" type="password" password :maxlength="16"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="14">
            <FormItem label="确认新密码" prop="newPasswordCheck">
              <Input v-model="changeFormValidate.newPasswordCheck" type="password" password :maxlength="16"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <p style="padding: 0 24px;">{{ $t('mmzs') }}</p>
      <div slot="footer">
        <Button type="primary" @click="changePswConfirm">确定</Button>
        <Button @click="changePswCancel">取消</Button>
      </div>
    </Modal>
    <a id='jump' :href="`${baseUrl}/sso/redirect/autoLogin?appSign=${appSign}&authorization=${token}`" :target="`sso${this.appSign}`" style="display: none;"></a>
  </div>
</template>

<script>
import CommonIcon from '_c/common-icon'
import { Validation } from '@/libs/util'
import { splitArray } from '@/libs/tools'
import { session, cookie } from '@/libs/location'
export default {
  name: 'home',
  components: {
    CommonIcon
  },
  data () {
    // 修改密码
    const validateNewPassword = (rule, value, callback) => {
      // /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
      if (value === this.changeFormValidate.originPassword) {
        callback(new Error(this.$t('loginPage.xmmbnyjmmxt')))
      } else if (
        !/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{10,30}$/.test(
          value
        ) || /[\u4E00-\u9FA5]/g.test(value)
      ) {
        callback(new Error(this.$t('loginPage.mmzswzmsztszfnew')))
      } else {
        callback()
      }
    }
    // 确认新密码
    const validateChangePassCheck = (rule, value, callback) => {
      if (value !== this.changeFormValidate.newPassword) {
        callback(new Error('loginPage.mmbyz'))
      } else {
        callback()
      }
    }
    return {
      carouselPageNo: 0,
      value: 0,
      coverImgUrl: require('../assets/images/home-img.jpg'),
      baseImg: require('../assets/images/home-img.jpg'),
      changeBackgroundPicModal: false, // 自定义底图弹窗
      changePasswordModal: false, // 修改密码弹窗
      showMoreflag: false, // 查看更多弹窗
      // 外部链接
      externalLinksList: [],
      showLinks: false,
      pageDto: {
        pageNo: 1,
        pageSize: 10
      },
      // 修改密码参数
      changeFormValidate: {
        originPassword: '',
        newPassword: '',
        newPasswordCheck: ''
      },
      // 修改密码验证
      changeRuleValidate: {
        originPassword: [
          { validator: Validation.passWord, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        newPasswordCheck: [
          { validator: validateChangePassCheck, trigger: 'blur' }
        ]
      },
      skinList: [],
      userInfo: {}, // 用户信息
      userId: '', // 用户id
      pageNo: 1, // 页码
      pageSize: 6, // 分页数量
      systemList: [], // 系统列表
      token: '',
      uploadName: '', // 上传文件名称
      uploadToken: {}, // 上传请求头部
      appSign: '', // 系统标识
      baseUrl: '' // 请求地址
    }
  },
  created () {
    if (!this.$route.query.token) {
      this.userInfo = JSON.parse(session.getItem('userInfo')) ? JSON.parse(session.getItem('userInfo')) : JSON.parse(cookie.getCookie('userInfo'))
      this.token = session.parseJSON() ? session.parseJSON() : cookie.getCookie('token')
      this.appSign = session.getItem('appSign')
      this.uploadToken = {
        'authorization': this.token === null ? '' : this.token,
        'Access-Control-Allow-Origin': '*'
      }
      this.doInit()
      // this.dpGetExternalLinks()
      this.doGetUploadImg()
    } else {
      this.getUesrInfoByToken(this.$route.query.token)
    }
  },
  mounted () {
    this.baseUrl = this.$baseUrl
    if (this.appSign) {
      let jump = document.getElementById('jump')
      jump.click()
      session.remove('appSign')
    }
    this.doGetSkinList()
    // 如果local里面有已选皮肤，则使用
    // if (local.getItem('skin') === 'no-background') {
    //   document.getElementsByClassName('background-color')[0].classList.remove('bgc-active')
    // } else {
    //   this.$store.commit('setSkin', local.getItem('skin'))
    // }
  },
  // computed: {
  //   skin () {
  //     return this.$store.state.user.skin
  //   }
  // },
  // watch: {
  //   skin: {
  //     handler (val, oldval) {
  //       this.$nextTick(() => {
  //         // app 入口文件内的颜色覆盖
  //         if (val) document.getElementById('app').classList.add(val)
  //         if (oldval) {
  //           document.getElementById('app').classList.remove(oldval)
  //         }
  //         document.getElementById('app').classList.add(local.getItem('skin'))
  //       })
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // 通过token获取用户信息
    getUesrInfoByToken (data) {
      this.$request.post('/sso/login/getSessionUser', { sessionId: data }).then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          let userInfo = {
            isAdmin: data.isAdmin,
            id: data.id,
            identityType: data.identityType,
            userCode: data.userCode,
            mobile: data.mobile,
            name: data.name
          }
          session.setObject(data.sessionId)
          session.setItem('userInfo', JSON.stringify(data))
          cookie.setCookie('token', data.sessionId)
          cookie.setCookie('userInfo', JSON.stringify(userInfo))
          this.$Message.success('登录成功')
          if (data.remindedMessage) this.$Message.info(data.remindedMessage)
          this.userInfo = data
          this.token = data.sessionId
          this.appSign = session.getItem('appSign')
          this.uploadToken = {
            'authorization': this.token,
            'Access-Control-Allow-Origin': '*'
          }
          this.doInit()
          this.doGetUploadImg()
        }
      })
    },
    // 跳转外部链接
    doJumpExternalLinks () {
      let newpage = this.$router.resolve({
        name: 'external_links'
      })
      window.open(newpage.href, 'ssoexl')
    },
    // 跳转颐海工作组架构
    doJumpSkillGroup () {
      let newpage = this.$router.resolve({
        name: 'skill_group'
      })
      window.open(newpage.href, 'ssosg')
    },
    // 初始化
    doInit () {
      this.$request.post('/sso/app/getUserAppPage').then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          let _finaArr = []
          let _copyData = splitArray(data, 6)
          _copyData.forEach((item, index) => {
            let _item = []
            if (item.length > 0) {
              item.forEach(k => {
                k.number = index + 1
                _item.push(k)
              })
              if (item.length < 6) {
                for (let index = 0; index < (6 - item.length); index++) {
                  _item.push({
                    number: item.length + 1
                  })
                }
              }
            }
            console.log(_item, 'item')
            _finaArr.push(_item)
          })
          this.systemList = _finaArr
          // if (_list.length < 6) {
          //   let length = _list.length
          //   for (let i = length + 1; i <= 6; i++) {
          //     _list.push({
          //       number: i
          //     })
          //   }
          //   this.systemList = _list
          // } else {
          //   this.systemList = _list
          // }
        } else {
          // this.$Message.warning(message)
        }
      })
    },
    // 跳转系统
    doJumpSystem (appSign) {
      if (appSign) {
        this.$request.post('/sso/sync/loginOutInfo').then(res => {
          let { code } = res.data
          if (code === 'OK') {
            window.open(`${this.baseUrl}/sso/redirect/autoLogin?appSign=${appSign}&authorization=${this.token}`, `sso${appSign}`)
          }
        })
      }
    },
    doClickLocation (url, id) {
      if (url.includes('http') || url.includes('https')) {
        window.open(`//${url.split('//')[1]}`, id)
      } else {
        window.open(`//${url}`, id)
      }
    },
    // 获取外部链接
    dpGetExternalLinks () {
      let req = {
        status: 0,
        pageDto: this.pageDto
      }
      this.$request.post('/sso/link/getLinkPage', req).then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          this.externalLinksList = data.list
        }
      })
    },
    doGetPreviousPage () {
      if (this.pageDto.pageNo > 1) {
        this.pageDto.pageNo--
      } else {
        this.pageDto.pageNo = 1
      }
      let req = {
        status: 0,
        pageDto: this.pageDto
      }
      this.$request.post('/sso/link/getLinkPage', req).then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          this.externalLinksList = data.list
        }
      })
    },
    doGetNextPage () {
      this.pageDto.pageNo++
      let req = {
        status: 0,
        pageDto: this.pageDto
      }
      this.$request.post('/sso/link/getLinkPage', req).then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          this.externalLinksList = data.list
        }
      })
    },
    // 用户名下拉菜单点击事件
    changeDropDown (name) {
      // 打开修改密码弹窗
      if (name === 'changePassword') {
        this.changePasswordModal = true
      } else if (name === 'BackgroundPic') {
        this.doChangeBackgroundPic()
      } else {
        this.doRestoreDefaultPic()
      }
    },
    // 获取皮肤列表
    doGetSkinList () {
      this.$request.post('/sso/userAttr/findSkinColor').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          let _skinList = JSON.parse(JSON.stringify(data))
          this.skinList = _skinList.map(k => {
            if (k.skinColor === JSON.parse(session.getItem('userInfo')).skinColor) {
              k.isDefault = 1
              this.$store.dispatch('doChangeSkin', k.skinColor)
            } else {
              k.isDefault = 0
            }
            return k
          })
        }
      })
    },
    // 切换皮肤
    onChangeSkin (name) {
      let _userInfo = JSON.parse(session.getItem('userInfo'))
      let _name = name
      console.log(_userInfo.skinColor, name, 'name')
      // if (_userInfo.skinColor === name) {
      //   _name = '#fff'
      // }
      this.$store.dispatch('doChangeSkin', _name)
      this.$request.post('/sso/userAttr/addOrUpdate', { skinColor: _name }).then(res => {
        const { code } = res.data
        if (code === 'OK') {
          // 更新缓存
          _userInfo.skinColor = _name
          session.setItem('userInfo', JSON.stringify(_userInfo))
          this.$Message.success(this.$t('czcg'))
        }
      })
    },
    // 修改密码弹窗-确定
    changePswConfirm () {
      this.$refs['changeFormValidate'].validate((valid) => {
        if (valid) {
          let req = {
            id: this.userInfo.id,
            oldPassword: this.changeFormValidate.originPassword,
            password: this.changeFormValidate.newPassword
          }
          this.$request.post('/sso/login/modPassword', req).then(res => {
            let { code } = res.data
            // let { code, message } = res.data
            if (code === 'OK') {
              this.$Message.success('密码修改成功')
              this.$refs['changeFormValidate'].resetFields()
              this.changePasswordModal = false
            } else {
              // this.$Message.warning(message)
            }
          })
        }
      })
    },
    // 修改密码弹窗-取消
    changePswCancel () {
      this.$refs['changeFormValidate'].resetFields()
      this.changePasswordModal = false
    },
    // 还原默认背景图片
    doRestoreDefaultPic () {
      if (this.userInfo.id === 0) {
        this.$request.post('/sso/imageFile/delImage').then(res => {
          let { code } = res.data
          if (code === 'OK') {
            this.coverImgUrl = this.baseImg
          }
        })
      } else {
        this.$Message.warning('只有超级管理员才有权限自定义背景图')
      }
    },
    // 打开自定义底图弹窗
    doChangeBackgroundPic () {
      if (this.userInfo.id === 0) {
        this.changeBackgroundPicModal = true
      } else {
        this.$Message.warning('只有超级管理员才有权限自定义背景图')
      }
    },
    // 自定义底图弹窗-确定
    changeBgPicConfirm () {
      this.changeBackgroundPicModal = false
      this.doGetUploadImg()
      this.$refs.upload.clearFiles()
      this.uploadName = ''
    },
    // 自定义底图弹窗-取消
    changeBgPicCancel () {
      this.changeBackgroundPicModal = false
      this.$refs.upload.clearFiles()
      this.uploadName = ''
    },
    // 获取背景图片
    doGetUploadImg () {
      this.$request.post('/sso/imageFile/getImageUrl').then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          if (data) {
            this.coverImgUrl = data
          }
        }
      })
    },
    // 上传成功
    doUploadSuccess (response, file) {
      this.uploadName = file.name
      this.$Message.success('上传成功')
    },
    // 上传失败
    doUploadError (warn, file) {
      this.$Message.warning('上传失败')
    },
    // 上传文件超过限制大小
    handleExceededSize (file) {
      this.$Message.warning('上传图片大小不能超过200KB')
    },
    // 上传文件验证格式失败
    handleFormatError (file) {
      this.$Message.warning('上传图片格式不正确')
    },
    // 退出
    doExit () {
      this.$request.post('/sso/login/logoutUser', { sessionId: this.token }).then(res => {
        let { code } = res.data
        if (code === 'OK') {
          cookie.removeCookie('token')
          cookie.removeCookie('userInfo')
          session.remove('token')
          session.remove('userInfo')
          this.$router.push({ name: 'login' })
          this.$Message.success('退出成功')
        }
      })
    },
    // 打开查看更多弹窗
    doOpenshowMore () {
      this.showMoreflag = true
    },
    // 关闭查看更多弹窗
    doCloseShowMoreModal () {
      this.showMoreflag = false
    }
  }
}
</script>

<style lang="less" scoped>
.ivu-carousel-dots {
  position: absolute;
  bottom: 20vh;
}
.ivu-carousel-dots li button {
  height: 6px;
}
.home{
  // background-position: center;
  // background-repeat: no-repeat;
  // background-size: cover;
  width: 100vw;
  height: 100vh;
  .home-bg-box {
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    // filter: blur(2px);
    opacity: .8;
  }
  .home-bg-box-color {
    background-color: #fff;
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100vh;
    opacity: .2;
    z-index: 1;
  }
  .page-content {
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9;
    .background-color{
      float: left;
      width: 100vw;
      height: 100vh;
      opacity: 0.2;
    }
    // 页面头部
    .home-header-bgc {
      position: absolute;
      width: 100%;
      height: 80px;
      opacity: 0.6;
      background-color: #FFFFFF;
    }
    .home-header {
      width: 100%;
      height: 80px;
      position: absolute;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 16px 180px;
      .skill-group-name {
        line-height: 80px;
        margin: 0 10px;
        color: #333;
        font-weight: bolder;
        color: #eb6969;
        cursor: pointer;
      }
      // 头部logo
      .header-logo{
        display: flex;
        display: -webkit-flex;
        .logo-pic {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        .logo-title {
          font-size: 20px;
          color: #000;
          align-self:center;
        }
      }
      // 头部右侧功能区域
      .home-actions {
        display: flex;
        align-self:center;
        align-items: center;
        height: 80px;
        text-align: right;
        .avator {
          border-radius: 50%;
          height: 36px;
          width: 36px;
          margin-right: 9px;
        }
        .home-icon {
          align-self:center;
          color: #333;
          vertical-align: super;
          margin-left: 24px;
        }
      }
    }
    // 页面主体
    .home-container{
      position: absolute;
      width: 100vw;
      top: 0;
      bottom: 0;
      margin-top: 80px;
      overflow: hidden;
      .page-middle{
        position: relative;
        left: 50%;
        // margin-top: 30vh;
        transform: translate(-50%, -50%);
        border: 10px solid hsla(0, 0%, 0%, .1);
        opacity: 0.9;
        width: 1190px;
        // height: 52vh;
        .middle-items {
          width: 1170px;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          .middle-up-item {
            width: 390px;
            height: 256px;
            display: inline-block;
            background: transparent;
            transition: .3s;
            &:hover {
              background: #5B1510 !important;
              .title, .desc, .number{
                color: #fff;
              }
              .title-arrow-right {
                opacity: 1;
                cursor: pointer;
                color: #fff;
              }
            }
          }
          .middle-up-item:nth-child(2n + 1) {
            background: #EEEEEE;
          }
          .middle-up-item:nth-child(2n) {
            background: #FFFFFF;
          }
          .middle-up-item-more {
            &:hover {
              background: #FFFFFF !important;
            }
          }
          .item-content {
            padding: 73px 24px 48px 24px;
          }
          .item-content {
            .title {
              width: 300px;
              height: 42px;
              color: #333333;
              font-size: 28px;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .title-arrow-right {
              opacity: 0;
              float: right;
              margin-top: -42px;
              margin-right: -8px;
            }
            .desc {
              width: 300px;
              height: 100px;
              color: #555555;
              font-size: 16px;
              line-height: 24px;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .number {
              float: right;
              margin-top: -48px;
              font-family: 'LoveloLineBold';
              font-size: 22px;
              color: #C82A1E;
            }
            .more {
              color: #C82A1E;
              font-size: 36px;
              margin: 30px 0 0 85px;
              i {
                margin-left: 10px;
              }
            }
          }
        }
      }
      .home-container-page {
        display: flex;
        justify-content: center;
        width: 100%;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        margin-left: -50%;
        bottom: 100px;
        .marker {
          width: 10px;
          height:10px;
          background:rgba(255,255,255,0.2);
          border:1px solid rgba(255, 255, 255, 1);
          border-radius:50%;
          margin-right: 32px;
          &:hover {
            border:1px solid #C82A1E;
          }
        }
        .marker-active {
          border:1px solid #C82A1E;
        }
      }
    }
    // 页面底部
    .home-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      .footer-title {
        color: #ffffff;
        margin-bottom: 7px;
        .footer-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 10px;
        }
        span {
          font-size:20px;
        }
      }
      .footer-content-bgc {
        float: left;
        height: 68px;
        width: 100%;
        background: #ffffff;
        opacity: 0.6;
      }
      .footer-content {
        width: 100%;
        height: 68px;
        position: absolute;
        padding: 13px 0;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        .footer-content-icon {
          color: #C82A1E;
          float: left;
          margin: 10px 24px 0 24px;
        }
        &-item {
          float: left;
          width: 42px;
          height: 42px;
          margin: 0 24px;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
  }
  // 查看更多弹窗
  .showMoreModal {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    opacity:0.9;
    z-index: 100;
    background-color: #C82A1E;
    .showMore-content {
      position: absolute;
      width: 50%;
      height: 360px;
      top: 50%;
      left: 25%;
      margin-top: -180px;
      display: flex;
      flex-direction: column;
      padding: 0 70px 40px;
      .showMore-header{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        span {
          font-size:30px;
          font-weight:bold;
          color:#FFFFFF;
        }
        .showMore-Close{
          position: absolute;
          right: 0;
          top: 0;
          color: #FFFFFF;
        }
      }
      .showMore-container {
        display: flex;
        justify-content: center;
        border-top: 4px solid #FFFFFF;
        ul {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          padding-top: 36px;
          li {
            width:200px;
            height:32px;
            font-size:16px;
            text-align: center;
            line-height: 32px;
            margin-bottom: 20px;
            div {
              color: #FFFFFF;
              &:hover {
                background:#FFFFFF;
                color: #C82A1E !important;
              }
            }
          }
        }
      }
    }
  }
  // 自定义底图弹窗
  .upload-modal {
    .ivu-modal-body {
      padding: 30px;
      height: 200px;
    }
    .upload-container {
      .upload-title {
        font-size:14px;
        color: #333333;
        opacity:0.85;
        line-height: 34px;
      }
      .ivu-input  {
        height: 34px;
      }
      .ivu-upload {
        width: 100%;
        margin-bottom: 4px;
      }
      .upload-input-icon{
        position: absolute;
        top: 7px;
        right: 7px;
      }
    }
  }
}
.ivu-carousel-dots li button{
  width: 30px;
  height: 15px;
}
.ivu-carousel-dots li.ivu-carousel-active>button {
  width: 60px;
  height: 15px;
}
.ivu-carousel{
  .ivu-carousel-arrow{
    width: 70px;
    height: 70px;
    font-size: 4em;
  }
  .ivu-icon{
    line-height: 1.4;
  }
}
@media (max-height: 768px){
  .page-middle{
    margin-top: 30vh;
  }
  .ivu-carousel-arrow{
    top: 40%;
  }
}
@media (min-height: 766px){
  .page-middle{
    margin-top: 34vh;
  }
  .ivu-carousel-arrow{
    top: 42%;
  }
}
@media (min-height: 800px){
  .page-middle{
    margin-top: 36vh;
  }
  .ivu-carousel-arrow{
    top: 43%;
  }
}
/* no */
@media (min-height: 830px){
  .page-middle{
    margin-top: 37vh;
  }
  .ivu-carousel-arrow{
    top: 43%;
  }
}
@media (min-height: 860px){
  .page-middle{
    margin-top: 40vh;
  }
  .ivu-carousel-arrow{
    top: 45%;
  }
}
@media (min-height: 900px){
  .page-middle{
    margin-top: 42vh;
  }
  .ivu-carousel-arrow{
    top: 46%;
  }
}
@media (min-height: 960px){
  .page-middle{
    margin-top: 44vh;
  }
  .ivu-carousel-arrow{
    top: 47%;
  }
}
@media (min-width: 1366px){
  .ivu-carousel-arrow.right{
    right: 20px;
  }
  .ivu-carousel-arrow.left{
    left: 20px;
  }
}
@media (min-width: 1400px){
  .ivu-carousel-arrow.right{
    right: 2%;
  }
  .ivu-carousel-arrow.left{
    left: 2%;
  }
}
@media (min-width: 1450px){
  .ivu-carousel-arrow.right{
    right: 3%;
  }
  .ivu-carousel-arrow.left{
    left: 3%;
  }
}
@media (min-width: 1500px){
  .ivu-carousel-arrow.right{
    right: 4%;
  }
  .ivu-carousel-arrow.left{
    left: 4%;
  }
}
@media (min-width: 1550px){
  .ivu-carousel-arrow.right{
    right: 5%;
  }
  .ivu-carousel-arrow.left{
    left: 5%;
  }
}
@media (min-width: 1600px){
  .ivu-carousel-arrow.right{
    right: 6%;
  }
  .ivu-carousel-arrow.left{
    left: 6%;
  }
}
@media (min-width: 1650px){
  .ivu-carousel-arrow.right{
    right: 7%;
  }
  .ivu-carousel-arrow.left{
    left: 7%;
  }
}
@media (min-width: 1700px){
  .ivu-carousel-arrow.right{
    right: 8%;
  }
  .ivu-carousel-arrow.left{
    left: 8%;
  }
}
@media (min-width: 1750px){
  .ivu-carousel-arrow.right{
    right: 9%;
  }
  .ivu-carousel-arrow.left{
    left: 9%;
  }
}
@media (min-width: 1800px){
  .ivu-carousel-arrow.right{
    right: 10%;
  }
  .ivu-carousel-arrow.left{
    left: 10%;
  }
}
@media (min-width: 1850px){
  .ivu-carousel-arrow.right{
    right: 11%;
  }
  .ivu-carousel-arrow.left{
    left: 11%;
  }
}
@media (min-width: 1910px){
  .ivu-carousel-arrow.right{
    right: 12%;/* no */
  }
  .ivu-carousel-arrow.left{
    left: 12%;/* no */
  }
}
// 换肤
.change-skin-box {
  padding: 24px 16px 16px 24px;/* no */
  width: 204px;/* no */
  height: 104px;/* no */
  .skin {
    display: inline-block;
    cursor: pointer;
    width: 24px;/* no */
    height: 24px;/* no */
    margin-right: 8px;/* no */
    margin-bottom: 8px;/* no */
  }
  .skin-default {
    background: #00a597;
  }
  .skin-blue {
    background: #6f9fff;
  }
  .skin-black {
    background: #1e3547;
  }
  .skin-red {
    background: #eb6969;
  }
}
</style>
